module.exports = __webpack_public_path__ + "static/media/amir_jaan_mood.2eace7cd.jpg";